// extracted by mini-css-extract-plugin
export var BtnV2 = "template-module--BtnV2--ffd62";
export var BtnV2Black = "template-module--BtnV2--black--114ee";
export var BtnV2Borderless = "template-module--BtnV2--borderless--1d41d";
export var BtnV2Cloud = "template-module--BtnV2--cloud--64e5b";
export var BtnV2Disabled = "template-module--BtnV2--disabled--9ea2e";
export var BtnV2Focusable = "template-module--BtnV2--focusable--8eedc";
export var BtnV2Fullwidth = "template-module--BtnV2--fullwidth--cf2d3";
export var BtnV2Gold = "template-module--BtnV2--gold--e62dc";
export var BtnV2Grey = "template-module--BtnV2--grey--76663";
export var BtnV2Icon = "template-module--BtnV2--icon--7b938";
export var BtnV2Lg = "template-module--BtnV2--lg--845d6";
export var BtnV2Midnight = "template-module--BtnV2--midnight--40615";
export var BtnV2Multiline = "template-module--BtnV2--multiline--bef50";
export var BtnV2Nofocus = "template-module--BtnV2--nofocus--ba406";
export var BtnV2Secondary = "template-module--BtnV2--secondary--1b209";
export var BtnV2Sm = "template-module--BtnV2--sm--67db2";
export var BtnV2Solid = "template-module--BtnV2--solid--b9caf";
export var BtnV2Square = "template-module--BtnV2--square--ffb77";
export var BtnV2Success = "template-module--BtnV2--success--975bb";
export var BtnV2Text = "template-module--BtnV2--text--13e89";
export var BtnV2Warning = "template-module--BtnV2--warning--6b5e8";
export var BtnV2White = "template-module--BtnV2--white--31ee0";
export var BtnV2Xl = "template-module--BtnV2--xl--2dcc9";
export var BtnV2Yellow = "template-module--BtnV2--yellow--0e909";
export var ColorBlock = "template-module--ColorBlock--8641f";
export var ColorBlockColorGrey = "template-module--ColorBlock--colorGrey--929d3";
export var ColorBlockGrey = "template-module--ColorBlock--grey--1f424";
export var ColorBlockMidGrey = "template-module--ColorBlock--midGrey--272ed";
export var ColorBlockPink = "template-module--ColorBlock--pink--b3912";
export var ColorBlockPrimary = "template-module--ColorBlock--primary--486f9";
export var ColorBlockPrimaryDark = "template-module--ColorBlock--primaryDark--3de0e";
export var ColorBlockPrimaryLight = "template-module--ColorBlock--primaryLight--2b9a3";
export var ColorBlockPrimaryMid = "template-module--ColorBlock--primaryMid--8e375";
export var ColorBlockPurple = "template-module--ColorBlock--purple--e8f9d";
export var ColorBlockRed = "template-module--ColorBlock--red--e6764";
export var ColorBlockSecondary = "template-module--ColorBlock--secondary--6528e";
export var ColorBlockSecondaryDark = "template-module--ColorBlock--secondaryDark--5b972";
export var ColorBlockSecondaryLight = "template-module--ColorBlock--secondaryLight--a834d";
export var ColorBlockSecondaryMid = "template-module--ColorBlock--secondaryMid--48a6c";
export var ColorBlockText = "template-module--ColorBlock--text--8053b";
export var ColorBlockYellow = "template-module--ColorBlock--yellow--ffaac";
export var ColorBlocks = "template-module--ColorBlocks--9b9ec";
export var DashboardTopoptions = "template-module--Dashboard--topoptions--bc657";
export var HideEmbedded = "template-module--HideEmbedded--2ca82";
export var ShowEmbedded = "template-module--ShowEmbedded--f246f";
export var Template__descriptionContent = "template-module--Template__description-content--cf1da";
export var __active = "template-module--__active--7c731";
export var __custom = "template-module--__custom--dab5a";
export var _pin = "template-module--_pin--5b1e3";
export var _pinText = "template-module--_pinText--e83d3";
export var aliceCarousel__dots = "template-module--alice-carousel__dots--66eb2";
export var aliceCarousel__dotsItem = "template-module--alice-carousel__dots-item--a213d";
export var btnGroup = "template-module--btn-group--244dd";
export var ccCompliance = "template-module--cc-compliance--b9df0";
export var embed = "template-module--embed--69f7f";
export var embedded = "template-module--embedded--7e3d6";
export var h1 = "template-module--h1--cbf00";
export var h2 = "template-module--h2--ff0d2";
export var h3 = "template-module--h3--f5d81";
export var h4 = "template-module--h4--61888";
export var link = "template-module--link--77984";
export var maxWidth = "template-module--max-width--a8996";
export var menuOpen = "template-module--menu-open--5621e";
export var noChildPMb = "template-module--no-child-p-mb--b3aa2";
export var nobar = "template-module--nobar--02862";
export var pin = "template-module--pin--e2de3";
export var seogroup = "template-module--seogroup--e2cd4";
export var wrapper = "template-module--wrapper--40c8f";